<div>{{'logout.message' | translate}}</div>